import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import ContentFeedGrid from "@/components/ContentFeedGrid";
import ContentFeedList from "@/components/ContentFeedList";

interface Props {
  contentFeedSearchResult: ContentFeedSearchResult | null;
  feedId: string;
  subscriptionLevels: SubscriptionLevel[];
  paymentPackages: PaymentPackage[];
  enableScroll: boolean;
  showFollowButton: boolean;
  showReportItem: boolean;
  showComment: boolean;
  showFooter: boolean;
  showShare: boolean;
  followedUsersId: Map<string, boolean>;
  feedListClasses?: string;
}

export default Vue.extend({
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const {
      contentFeedSearchResult,
      feedId,
      subscriptionLevels,
      paymentPackages,
      enableScroll,
      showFollowButton,
      showReportItem,
      showComment,
      showFooter,
      showShare,
      followedUsersId,
      feedListClasses,
    } = ctx.props;
    return h("div", { class: ctx.data.class, staticClass: ctx.data.staticClass }, [
      feedId &&
        h(ContentFeedList, {
          key: `list${ctx.data.key}`,
          class: feedListClasses,
          props: {
            scrollToFeed: feedId,
            contentFeedList: (contentFeedSearchResult && contentFeedSearchResult.result) || [],
            subscriptionLevels: subscriptionLevels,
            paymentPackages: paymentPackages,
            scroll: enableScroll,
            showFollowButton,
            showReportItem,
            showComment,
            showFooter,
            showShare,
            followedUsersId: followedUsersId,
          },
          on: ctx.listeners,
          attrs: {},
        }),
      h(ContentFeedGrid, {
        key: `grid${ctx.data.key}`,
        style: { display: !feedId ? "" : "none" },
        props: {
          feedId: feedId,
          enableScroll: enableScroll,
          contentFeedList: (contentFeedSearchResult && contentFeedSearchResult.result) || [],
        },
        on: ctx.listeners,
        attrs: {},
      }),
    ]);
  },
});
